import { SelectInputModel } from 'src/app/services/ricerca-pratiche.service';
import { switchMap, map } from 'rxjs/operators';
import { Observable, of, forkJoin } from 'rxjs';
import { Injectable } from '@angular/core';
import { RicercaPraticheService } from './ricerca-pratiche.service';
import { FrontOfficeService } from './front-office.service';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  private province: SelectInputModel[];
  private areeGaranzia: SelectInputModel[];
  private fasi: SelectInputModel[];
  private procedureYears: string[];
  private luoghiRestrizione: any;
  private euStates: any;
  private intStates: any;
  private docTypes: any;
  private iniziativeSegnalazione: any;
  private istruttori: { id: number; descrizione: string; };
  private tipoSegnalazione: any;
  private tipoChiusura: any;
  private tipoEsito: any;
  private tipoProva: any;
  private circPen: any;
  private collocazione: any;
  private foroIscrizione: any;
  private criticita: any;
  private tipoServizio: any;
  private statoCoppia: any;
  private catSoggRichiedente: any;
  private statiPraticaByIdFase = [];

  public getProvince(): SelectInputModel[] {
    return this.province;
  }

  public getAreeGaranzia(): SelectInputModel[] {
    return this.areeGaranzia;
  }

  public getFasi(): SelectInputModel[] {
    return this.fasi;
  }

  public getProcedureYears(): string[] {
    return this.procedureYears;
  }

  public getLuoghiRestrizione(): any {
    return this.luoghiRestrizione;
  }

  public getEuStates(): any {
    return this.euStates;
  }

  public getIntStates(): any {
    return this.intStates;
  }

  public getDocTypes(): any {
    return this.docTypes;
  }

  public getIniziativeSegnalazione(): any {
    return this.iniziativeSegnalazione;
  }

  public getIstruttori(): any {
    return this.istruttori;
  }

  public getTipoSegnalazione(): any {
    return this.tipoSegnalazione;
  }

  public getTipoChiusura(): any {
    return this.tipoChiusura;
  }

  public getTipoEsito(): any {
    return this.tipoEsito;
  }

  public getTipoProva(): any {
    return this.tipoProva;
  }

  public getCircPen(): any {
    return this.circPen;
  }

  public getCollocazione(): any {
    return this.collocazione;
  }

  public getForoIscrizione(): any {
    return this.foroIscrizione;
  }

  public getCriticita(): any {
    return this.criticita;
  }

  public getTipoServizio(): any {
    return this.tipoServizio;
  }

  public getStatoCoppia(): any {
    return this.statoCoppia;
  }

  public getCatSoggRichiedente(): any {
    return this.catSoggRichiedente;
  }

  public getStatiPraticaByIdFasi(idFase: number): Array<any> {
    return this.statiPraticaByIdFase[idFase];
  }

  constructor(
    private ricercaPraticheService: RicercaPraticheService,
    private frontOfficeService: FrontOfficeService
    ) {}

  load() {
    return forkJoin([
      this.ricercaPraticheService.getProvice(), // 0
      this.ricercaPraticheService.getIstitutiGaranzia(),
      this.ricercaPraticheService.getFasiPratica(), // 2
      this.ricercaPraticheService.getAnnoPratica(), // 3
      this.frontOfficeService.getLuoghiRestrizione(), // 4
      this.frontOfficeService.getStatesByCitizenshipId(2), // 5
      this.frontOfficeService.getStatesByCitizenshipId(3), // 6
      this.frontOfficeService.getTipoAllegato(), // 7
      this.ricercaPraticheService.getIniziativeSegnalazione(), // 8
      this.ricercaPraticheService.getIstruttori(), // 9
      this.ricercaPraticheService.getTipoSegnalazione(), // 10
      this.ricercaPraticheService.getTipoChiusura(), // 11
      this.ricercaPraticheService.getTipoEsito(), // 12
      this.ricercaPraticheService.getTipoProv(), // 13
      this.ricercaPraticheService.getCircuitoPen(), // 14
      this.ricercaPraticheService.getStrutturaCollocazione(), // 15
      this.ricercaPraticheService.getTipoForoIscrizione(), // 16
      this.ricercaPraticheService.getCriticita(), // 17
      this.ricercaPraticheService.getTipoServizio(), // 18
      this.ricercaPraticheService.getStatoCoppia(), // 19
      this.ricercaPraticheService.getCategorieSoggettoByTipoSoggettoId(1), // 20
    ]).toPromise().then( (val: Array<any>) => {
      this.province = val[0] as SelectInputModel[],
      this.areeGaranzia = val[1] as SelectInputModel[],
      this.fasi = val[2] as SelectInputModel[],
      this.procedureYears = val[3] as string[],
      this.luoghiRestrizione = val[4],
      this.euStates = val[5],
      this.intStates = val[6],
      this.docTypes = val[7],
      this.iniziativeSegnalazione = val[8],
      this.istruttori = (val[9] as any).map((v: any) => ({ id: v.id, descrizione: `${v.nome} ${v.cognome}` })),
      this.tipoSegnalazione = val[10],
      this.tipoChiusura = val[11],
      this.tipoEsito = val[12],
      this.tipoProva = val[13],
      this.circPen = val[14],
      this.collocazione = val[15],
      this.foroIscrizione = val[16],
      this.criticita = val[17],
      this.tipoServizio = val[18],
      this.statoCoppia = val[19],
      this.catSoggRichiedente = val[20];
      // stati pratica by id fasi
      for (const fase of val[2])
        this.ricercaPraticheService.getStatiPraticaByIdFasi(fase.id).toPromise().then(stati => {
          this.statiPraticaByIdFase[fase.id] = stati;
        });
    });
  }

}
